export default "/images/mobileBlack.svg?5d96a9ac192812c226db4a9fb4daa362";